
<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Subir imágenes área de ECOGRAFÍA ({{numeroOrden}})</h4><span
    class="text-muted mt-1 tx-13 ms-2 mb-0">/ Ordenes / Inicio</span>
  </div>
</div>
<div class="d-flex my-xl-auto right-content mr-2">

  <div class="mb-3 mb-xl-0">

    <button type="button" class="btn btn-primary" (click)="subirImagenes()"><i class="icon ion-ios-filing"></i> GUARDAR</button>&nbsp;
    &nbsp;
    <button type="button" class="btn btn-light" (click)="volverAtras()">VOLVER</button>

  </div>
</div>
</div>
@if (spinnerBoolean) {
  <div class="text-center">
    <hr>
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="text-center">{{cargando}}</p>
    </div>
  }
  <div class="row row-sm">
    <div class="col-md-12">
      <div class="card">
        <h6 class="card-title text-uppercase p-2  text-white mb-1" style="background-color:#2E3D8C">
          Datos de la orden
        </h6>
        <div class="card-body">



          <div class="mb-2">
            <b>PACIENTE</b>
            <p>{{nombrePaciente}}</p>

          </div>
          <div class="mb-2">
            <b>DOCTOR</b>
            <p>{{nombreDoctor}}</p>

          </div>

          <div class="mb-2">
            <b>SUBIR ORDEN FISICA</b><br>
            <input type="file" (change)="ordenFisica($event)"><br><br>


          </div>
        </div>





      </div>
    </div>
    <div class="col-md-12">
      <div class="card">
        <h6 class="card-title text-uppercase p-2  text-white mb-1" style="background-color:#2E3D8C">
          Detalle Orden
        </h6>
        <div class="card-body">


          <table class="table table-striped tablaServicioOrden" width="100%">
            <thead>
              <tr>
                <th>#</th>
                <th>Observación</th>

                <th>Imagenes</th>
                <th>Video</th>
                <th>Documento</th>





              </tr>
            </thead>

            <tbody class="servicios">

              @for (dynamic of detalleOrden; track dynamic; let i = $index) {
                <tr >
                  @if (detalleOrden[i].tipo == 'ECOGRAFIA' ||  detalleOrden[i].tipo == 'ECOGRAFIAS ESPECIALES') {
                    <td> {{i+1}}</td>
                  }
                  @if (detalleOrden[i].tipo == 'ECOGRAFIA' ||  detalleOrden[i].tipo == 'ECOGRAFIAS ESPECIALES') {
                    <td style="width:500px;"><b>SERVICIO:</b> {{detalleOrden[i].producto}}<br><textArea type="text" class="form-control textWidth descripcion"  name="nombre"  readonly>{{detalleOrden[i].pieza}}</textArea></td>
                  }
                  @if (detalleOrden[i].tipo == 'ECOGRAFIA' ||  detalleOrden[i].tipo == 'ECOGRAFIAS ESPECIALES') {
                    <td style="width:1100px;">
                      <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'"  [expandable]="true" (change)="onSelect($event,detalleOrden[i].imagenes,detalleOrden[i].imagenesBase)">
                        <ngx-dropzone-label>
                          <div>
                            <h2> {{detalleOrden[i].producto}}</h2>
                          </div>
                        </ngx-dropzone-label>
                        @for (f of detalleOrden[i].imagenes; track f) {
                          <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview"
                            [file]="f" [removable]="true" (removed)="onRemove(f,detalleOrden[i].imagenes,detalleOrden[i].imagenesBase)">
                            <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                          </ngx-dropzone-image-preview>
                        }
                      </div>
                      <hr>
                        <div class="form-row">
                          @for (f of detalleOrden[i].imagenesSubidas; track f; let j = $index) {
                            <div class="col-md-6"><img  [src]="f.imagen"> <button class="btn btn-danger btn-sm text-center" (click)="borrarItem(detalleOrden[i].imagenesSubidas, j)"> <i class="fa fa-trash"></i></button></div>
                          }
                        </div>
                      </td>
                    }
                    @if (detalleOrden[i].tipo == 'ECOGRAFIA' ||  detalleOrden[i].tipo == 'ECOGRAFIAS ESPECIALES') {
                      <td style="width:700px;">
                        <input type="file" style="width:70%" (change)="subirVideos($event,detalleOrden[i].videos,detalleOrden[i].videosBase);"><hr>
                        <div class="form-row">
                          @for (f of detalleOrden[i].videosSubidos; track f; let j = $index) {
                            <div class="col-md-12"><a href="#" (click)="verContenidoVideo(f,$event)"  target="_blank">{{(i+1)}}.-Ver video</a>&nbsp;&nbsp; <button class="btn btn-danger btn-sm" (click)="borrarItem(detalleOrden[i].videosSubidos, j)">  <i class="fa fa-trash"></i></button></div>
                          }
                        </div>
                      </td>
                    }
                    @if (detalleOrden[i].tipo == 'ECOGRAFIA' ||  detalleOrden[i].tipo == 'ECOGRAFIAS ESPECIALES') {
                      <td style="width:700px;">
                        <input type="file" style="width:70%"  (change)="subirDocumentos($event,detalleOrden[i].documentos,detalleOrden[i].documentosBase);">
                        <input type="file" style="width:70%"  (change)="subirDocumentos($event,detalleOrden[i].documentos,detalleOrden[i].documentosBase);">
                        <input type="file" style="width:70%"  (change)="subirDocumentos($event,detalleOrden[i].documentos,detalleOrden[i].documentosBase);">
                        <input type="file" style="width:70%"  (change)="subirDocumentos($event,detalleOrden[i].documentos,detalleOrden[i].documentosBase);">
                        <input type="file" style="width:70%"  (change)="subirDocumentos($event,detalleOrden[i].documentos,detalleOrden[i].documentosBase);"><hr>
                        <div class="form-row">
                          @for (f of detalleOrden[i].documentosSubidos; track f; let j = $index) {
                            <div class="col-md-12"><a  href="#" (click)="verContenidoDocumentos(f,$event)" target="_blank">{{(j+1)}}.-Ver documento</a>&nbsp;&nbsp; <button class="btn btn-danger btn-sm" (click)="borrarItem(detalleOrden[i].documentosSubidos, i)">  <i class="fa fa-trash"></i></button><br><br></div>
                          }
                        </div>
                      </td>
                    }
                  </tr>
                }





              </tbody>


            </table>

          </div>





        </div>
      </div>
    </div>